import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryHomonymsSearchFailedAction = {
	type: 'BENEFICIARY_HOMONYMS_SEARCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryHomonymsSearchFailedAction => ({
	type: 'BENEFICIARY_HOMONYMS_SEARCH_FAILED',
	payload,
});
